import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const recentSales = [{
  name: 'María G.',
  country: 'México',
  flag: '🇲🇽',
  time: 'hace 2 min'
}, {
  name: 'Camila R.',
  country: 'Colombia',
  flag: '🇨🇴',
  time: 'hace 5 min'
}, {
  name: 'Valentina S.',
  country: 'Argentina',
  flag: '🇦🇷',
  time: 'hace 8 min'
}, {
  name: 'Lucía P.',
  country: 'Chile',
  flag: '🇨🇱',
  time: 'hace 12 min'
}, {
  name: 'Ana M.',
  country: 'Perú',
  flag: '🇵🇪',
  time: 'hace 15 min'
}, {
  name: 'Jennifer L.',
  country: 'Estados Unidos',
  flag: '🇺🇸',
  time: 'hace 18 min'
}, {
  name: 'Daniela F.',
  country: 'Ecuador',
  flag: '🇪🇨',
  time: 'hace 22 min'
}, {
  name: 'Sofía T.',
  country: 'República Dominicana',
  flag: '🇩🇴',
  time: 'hace 25 min'
}, {
  name: 'Isabella C.',
  country: 'Venezuela',
  flag: '🇻🇪',
  time: 'hace 30 min'
}, {
  name: 'Fernanda H.',
  country: 'Guatemala',
  flag: '🇬🇹',
  time: 'hace 35 min'
}, {
  name: 'Gabriela V.',
  country: 'Costa Rica',
  flag: '🇨🇷',
  time: 'hace 40 min'
}, {
  name: 'Andrea B.',
  country: 'Uruguay',
  flag: '🇺🇾',
  time: 'hace 45 min'
}, {
  name: 'Laura D.',
  country: 'Paraguay',
  flag: '🇵🇾',
  time: 'hace 50 min'
}, {
  name: 'Patricia N.',
  country: 'Panamá',
  flag: '🇵🇦',
  time: 'hace 55 min'
}, {
  name: 'Carolina M.',
  country: 'Bolivia',
  flag: '🇧🇴',
  time: 'hace 1 hora'
}, {
  name: 'Stephanie R.',
  country: 'Estados Unidos',
  flag: '🇺🇸',
  time: 'hace 1 hora'
}, {
  name: 'Diana L.',
  country: 'Honduras',
  flag: '🇭🇳',
  time: 'hace 1 hora'
}, {
  name: 'Alejandra K.',
  country: 'El Salvador',
  flag: '🇸🇻',
  time: 'hace 2 horas'
}, {
  name: 'Natalia J.',
  country: 'México',
  flag: '🇲🇽',
  time: 'hace 2 horas'
}, {
  name: 'Paola W.',
  country: 'Colombia',
  flag: '🇨🇴',
  time: 'hace 3 horas'
}];
export function SalesNotifications() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNotification = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % recentSales.length);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, []);
  useEffect(() => {
    // First notification after 6 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 6000);
    // Then every 8-15 seconds
    const interval = setInterval(() => {
      const randomDelay = Math.random() * 7000 + 8000;
      setTimeout(showNotification, randomDelay % 5000);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  const sale = recentSales[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-256">
      <AnimatePresence data-id="element-257">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 10,
        x: -20
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white rounded-xl shadow-lg border border-blush p-4 flex items-center gap-3 max-w-xs" data-id="element-258">
            <div className="w-10 h-10 bg-blush rounded-full flex items-center justify-center shrink-0" data-id="element-259">
              <ShoppingBag className="w-5 h-5 text-rose" data-id="element-260" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-261">
              <p className="text-sm font-semibold text-warm-dark leading-tight" data-id="element-262">
                {sale.name}{' '}
                <span className="text-lg leading-none" data-id="element-263">{sale.flag}</span>
              </p>
              <p className="text-xs text-warm-muted" data-id="element-264">
                Compró desde {sale.country}
              </p>
              <p className="text-[10px] text-warm-muted/70 mt-0.5" data-id="element-265">
                {sale.time}
              </p>
            </div>
            <div className="w-2 h-2 bg-success rounded-full shrink-0 animate-pulse" data-id="element-266"></div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}